/**
 * Which build is this tab running, and is a newer one deployed?
 *
 * The CRA build names its bundle `static/js/main.<hash>.js`, so the hash is a
 * free build id: read it from the loaded <script> tag, and from a fresh copy
 * of index.html to see what is deployed now. Dev builds (bundle.js) have no
 * hash → null, and everything here switches itself off.
 */

const MAIN_RE = /\/static\/js\/main\.([0-9a-f]{6,})\.js/;

export function versionFromHtml(html) {
  const m = MAIN_RE.exec(html || '');
  return m ? m[1] : null;
}

/** Build id of the code running in this tab (null in development). */
export function currentVersion(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc) return null;
  for (const s of Array.from(doc.scripts || [])) {
    const m = MAIN_RE.exec(s.src || '');
    if (m) return m[1];
  }
  return null;
}

/** Build id currently deployed (null if it can't be told). */
export async function fetchLatestVersion() {
  // GitHub Pages caches index.html for 10 min — bypass it.
  const res = await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) return null;
  return versionFromHtml(await res.text());
}

/** Reload onto the deployed build (a function so tests can stub it). */
export function reloadPage() { window.location.reload(); }
